/**
 * Created by Ninghai on 2017/12/20.
 */
import axios from 'axios'
import VueCookie from 'vue-cookie'
import {serviceUrl} from '@/utils/constant'
import store from '../store'
import { SET_USER_MESSAGE } from '../store/mutation-types'
// import {LOGOUT} from '@/store/mutation-types'
import router from '@/router'

axios.defaults.timeout = 500000
axios.defaults.baseUrl = serviceUrl

// http request 拦截器
axios.interceptors.request.use(
  config => {
    // 优先使用cookie
    let cookieToken = VueCookie.get('token')
    let cookieUserId = VueCookie.get('user_id')
    let storeToken = store.state.token
    let storeUserId = store.state.user_id
    if (cookieToken && cookieUserId) config.headers.Authorization = `user-${cookieUserId}-${cookieToken}`
    else if (storeToken && storeUserId) {
      config.headers.Authorization = `user-${storeUserId}-${storeToken}`
    }
    return config
  },
  error => {
    return Promise.reject(error)
  }
)

// http response 拦截器
axios.interceptors.response.use(
  res => {
    return res.data
  },
  error => {
    /** if (error.response) {
          switch (error.response.status) {
            case 401 :
              store.commit(LOGOUT)
              router.replace({
                path: 'login',
                query: {redirect: router.currentRoute.fullPath}
              })
          }
        }
     */
    if (error.response.status === 401 || error.response.status === 403) {
      router.push('login')
      VueCookie.delete('user_id')
      VueCookie.delete('token')
      store.commit({
        type: SET_USER_MESSAGE,
        user_id: undefined,
        token: undefined,
        username: undefined
      })
    }
    else{
      console.log(error)
    }
    return Promise.reject(error.response)
  }
)

export default ({method = 'GET', url, data, params}) => axios({method, url, data, params})



// WEBPACK FOOTER //
// ./src/services/fetch.js